import http, { API_CORE } from '../http';

export default function OrderItemStatusService() {
  const getStatuses = async (params) => {
    const response = await http(API_CORE).get('/orders/item-statuses', {
      params: params,
    });
    return response.data;
  };

  const getStatusById = async (id) => {
    const response = await http(API_CORE).get(`/orders/item-statuses/${id}`);
    return response.data;
  };

  const createStatus = async (input) => {
    const response = await http(API_CORE).post('/orders/item-statuses', input);
    return response.data;
  };

  const updateStatus = async (id, input) => {
    const response = await http(API_CORE).put(`/orders/item-statuses/${id}`, input);
    return response.data;
  };

  const deleteStatus = async (id) => {
    const response = await http(API_CORE).delete(`/orders/item-statuses/${id}`);
    return response.data;
  };

  return {
    getStatuses: getStatuses,
    getStatusById: getStatusById,
    createStatus: createStatus,
    updateStatus: updateStatus,
    deleteStatus: deleteStatus,
  };
}
